import styled, { css } from 'styled-components';

export const Text = styled.p`
  font-size: 8;
  text-align: center;
`;
